$(window).on('load', function() {
    if ($('#modal-required-user-full-information').length) {
        $('#modal-required-user-full-information').modal('show');
    }

    $(document).on('click', '.btn-view-violation', function () {
        const rawData = $(this).data('error') || $(this).data('warning');
        if (!rawData) return;

        const isError = typeof $(this).data('error') !== 'undefined';
        const isWarning = typeof $(this).data('warning') !== 'undefined';
        const rulesConfig = window.VIRTUAL_RACE_RULES || {};

        const formattedData = [];
        for (const [raceName, rules] of Object.entries(rawData)) {
            if (typeof rules !== 'object' || rules === null) continue;

            const errors = [];
            const warnings = [];

            for (const [ruleName, ruleVal] of Object.entries(rules)) {
                let template = rulesConfig[ruleName] || ruleName;

                if (typeof ruleVal === 'object' && ruleVal !== null) {
                    for (const [k, v] of Object.entries(ruleVal)) {
                        template = template.replaceAll(k, v);
                    }
                }

                if (isWarning) {
                    warnings.push(template);
                } else {
                    errors.push(template);
                }
            }

            if (errors.length > 0 || warnings.length > 0) {
                formattedData.push({
                    raceName,
                    errors,
                    warnings
                });
            }
        }

        let html = '';
        formattedData.forEach((item, index) => {
            html += `<h5 class="font-size-16 bolder">• ${item.raceName}</h5>`;
            const isLast = index === formattedData.length - 1;
            const ulClass = isLast ? 'mb-0' : 'mb-3';
            html += `<ul class="${ulClass}">`;
            
            item.errors.forEach(err => {
                html += `<li>❌ ${err}</li>`;
            });
            item.warnings.forEach(warn => {
                html += `<li>⚠️ ${warn}</li>`;
            });
            html += `</ul>`;
        });

        const isVi = typeof CURRENT_LANG !== 'undefined' ? CURRENT_LANG === 'vi' : true;
        const title = isError 
            ? (isVi ? 'HOẠT ĐỘNG KHÔNG HỢP LỆ' : 'INVALID ACTIVITY')
            : (isVi ? 'CẢNH BÁO HOẠT ĐỘNG' : 'ACTIVITY WARNING');

        const modal = $('#modal-invalid-activity');
        if (modal.length) {
            modal.find('.modal-header h5').text(title);
            modal.find('.modal-body').html(html);
            modal.modal('show');
        }
    });
});

$(function() {
    $('.lazy-load-image').Lazy();
    
    // Tự động kích hoạt lazy load cho các phần tử được tải thêm qua AJAX
    $(document).ajaxComplete(function() {
        $('.lazy-load-image').Lazy();
    });
});

$(function() {
    $("html").click(function (event) {
        if ($(event.target).closest("#topnav-menu-content").length === 0) {
            $("#topnav-menu-content").removeClass("show");
            $("#topnav-menu-content")
                .find(".nav-item.dropdown.active")
                .find(".show")
                .removeClass("show");
            $("#topnav-menu-content")
                .find(".nav-item.dropdown.active")
                .removeClass("active");
        }
    });

    $("#topnav-menu-content .navbar-nav").on(
        "click",
        "li.nav-item.dropdown",
        function (e) {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).find(".dropdown-menu").first().removeClass("show");
            } else {
                $(this).siblings(".active").find(".show").removeClass("show");
                $(this).siblings(".active").removeClass("active");
                $(this).addClass("active");
                $(this).find(".dropdown-menu").first().addClass("show");
            }
        }
    );

    $("#topnav-menu-content .navbar-nav").on(
        "click",
        ".dropdown-child",
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).find(".dropdown-menu").first().removeClass("show");
            } else {
                $(this).addClass("active");
                $(this).find(".dropdown-menu").first().addClass("show");
            }
        }
    );

    $("#topnav-menu-content .navbar-nav").on(
        "click",
        ".dropdown-child .dropdown-menu a",
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = $(this).attr("href");
        }
    );
});